// extracted by mini-css-extract-plugin
module.exports = {"container":"OkCancelButtons_container__R-Yi6","cancel":"OkCancelButtons_cancel__2ktqp","ok":"OkCancelButtons_ok__1K-Vt"};